export default __webpack_public_path__ + "static/imgix-d31be8b596da464e6460e66d519edf8f.svg";